const PHONE = "0604026840";
const WHATSAPP_URL = `https://wa.me/33604026840?text=Bonjour%2C%20j%27ai%20besoin%20d%27un%20serrurier%20en%20urgence`;

export default function MobileCallBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden flex border-t border-gray-200 bg-white">
      <a
        href={`tel:${PHONE}`}
        className="flex-1 flex items-center justify-center gap-2 bg-black text-white font-black text-sm py-4 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-phone-fill text-base"></i>
        06 04 02 68 40
      </a>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="nofollow noopener noreferrer"
        className="flex-1 flex items-center justify-center gap-2 bg-[#FFB100] text-black font-black text-sm py-4 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-whatsapp-line text-base"></i>
        WhatsApp
      </a>
    </div>
  );
}
